export default {
  INCREMENT_CURRENT_STEP(state) {
    state.currentStep++
  },
  DECREMENT_CURRENT_STEP(state) {
    state.currentStep--
  },
  UPDATE_CURRENT_STEP(state, payload) {
    if (state.currentStep === 0 && payload.order !== 0 && payload.shouldTriggerBasicFormSubmit) {
      state.basicFormSubmit = {trigger: true, goTo: payload.order};
      return;
    }
    state.basicFormSubmit = {trigger: false, goTo: undefined};
    state.currentStep = payload.order;
  },
  UPDATE_BASIC_FORM_SUBMIT(state, payload) {
    state.basicFormSubmit = payload
  },
  COMPLETE_STEP(state) {
    if (!state.steps[state.currentStep].completed) state.steps[state.currentStep].completed = true
  },
  UPDATE_PROGRESS: (state, { basicInfo }) => {
    const basicInfoTotalProgress = Object.keys(basicInfo.basicInfo).filter(key => basicInfo.basicInfo[key] != '').length * 4.5
    state.step.progress += basicInfoTotalProgress
  },
  COMPLETE_STEPS_AFTER_PARSER: (state, payload) => state.steps[payload.index].completed = true,

  CLEAR_CURRENT_STEP: (state, payload) => state.currentStep = payload,

  CLEAR_SECOND_STEP: (state, payload) => state.secondStep = payload,

  CLEAR_STEP_STEP: (state, payload) => state.step = { ...payload },

  CLEAR_STEPS: (state, payload) => state.steps = [...payload],

  CLEAR_BASIC_FORM_SUBMIT: (state, payload) => state.basicFormSubmit = { ...payload },

  UPDATE_STEPS_DYNAMICALY: (state, steps) => {
    state.steps = steps;
  }
}
